module.exports = __webpack_public_path__ + "img/bus-simple.a01bfe76.svg";